<template>
  <div class="pt-3">
    <h5 class="font-weight-bold">Fotos</h5>
    <div class="picswrap pb-3">
      <div class="cpics border-top container horizontal-scrollable p-0">
        <div class="form-row ml-0 mr-0 mt-2">
          <div class="col-md-6 pl-0" v-for="(photo ,i) in photos" :key="i">
            <div class="simple-photo m-0" :class="{auto : (i === 0)}">
              <Popup :photo="photo" :taskModule="true"/>
              <div  data-aspect-ratio="4:3" class="img-fluid">

                <photodisplay :image="photo" :moveable="true" />

<!--                <div :style="{'background-image': 'url(\'' + photo.src + '\')'}"></div>-->

              </div>
<!--               <img class="w-100 shadow-sm" :src="photo.src" alt="img1" height="163">-->
              <div class="simple-photo-option">
                <ul>
                  <li>Nr.{{ photo.runid }}</li>
                  <li>|</li>
                  <li>{{ photo.photodate | dateFormat }}  </li>
                  <li>|</li>
                  <li>{{ photo.photodate.substr(11,5) }} Uhr</li>
                </ul>
              </div>
            </div>
            <div class="card p-1 font13">
              <p>
                <strong class="font13">Beschreibung :</strong>
              </p>
              <p style="min-height: 2rem">
               {{setPhotoText(photo.pdphotoid)}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Popup from '../../photo/components/infoPopup'
import {formatDate} from '../../common'
import Photodisplay from '../../photoDocumentation/common/photodisplay.vue'
export default {
  // props: ['flawitems'],
  components: {Photodisplay, Popup},
  data(){
    return {}
  },
  mounted () {
   //mounted
  },
  computed: {
    photos() {
      return this.$store.state.tasks.taskPhotos
    },
    flawitems(){
      return this.$store.state.tasks.taskDetails.flawitems
    }
  },
  // flawitems
  methods: {
    setPhotoText(id){
      const task = this.flawitems.find(item => item.pdphotoid == id)
      return task ? task.pdphototext : "";
    }
  },
  filters: {
    dateFormat: (val) => formatDate(val),
  }

}
</script>
<style scoped>
.horizontal-scrollable > .form-row {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  min-height: 18rem;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .6);
  background-color: #3399ff9e;
  opacity: 1;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  background-color: #ffffff;
}
.horizontal-scrollable > .form-row::-webkit-scrollbar {
  width: 6px;
  background-color: #ffffff;
  max-height: 8px;
}
.horizontal-scrollable > .form-row > .col-md-6 {
  display: inline-block;
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/preview-tabs/PhotosTab.vue